import React from 'react';
// import Modal from "react-animated-modal";
import {Card, Modal} from 'react-bootstrap'
// import Aux from "../../hoc/_Aux";

class CustomModal extends React.Component {

    render() {
        const {style,headerClassName='bg-c-blue',props,size='xl',fullscreen=false,className,  showHeader=true, pop=false }=this.props
        return (
            // <Aux>
                
            <Modal
                show={this.props.showModal}
                onHide={pop ? undefined : this.props.onClose}
                size={size}
                fullscreen={fullscreen}
                centered={pop}
                backdrop={pop ? "static" : true}
                keyboard={!pop}
                style={pop ? {
                    marginTop: "20px",
                    borderRadius: "10px",
                    padding: "10px"
                } : {}}
                className={className}
                {...props}
            >

                <Card
                    style={pop ? {
                        borderRadius: "10px",
                        marginBottom: "0px",
                        boxShadow: "0 10px 35px rgba(0,0,0,0.15)",
                        overflow: "hidden"
                    } : {}}
                >

                    {showHeader && (
                        <Card.Header
                            as="h5"
                            className={headerClassName}
                            style={{
                                display: 'flex',
                                justifyContent: pop ? 'center' : 'space-between',
                                alignItems: 'center',
                                padding: pop ? "12px 18px" : '0px',
                                fontWeight: pop ? "600" : '',
                                backgroundColor: pop ? "rgb(9 98 161)" : ''
                            }}
                        >
                            {this.props.title || 'Title'}
                            {this.props.anyComponent}

                            {pop !== true && (
                                <span onClick={this.props.onClose} style={{ cursor: 'pointer' }}>
                                    <i
                                        style={{ color: '#fff', fontSize: 21 }}
                                        className="fa fa-times-circle"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            )}
                        </Card.Header>
                    )}

                    <Card.Body
                        style={{
                            ...style,
                            padding: pop ? "30px" : "0px",
                            maxHeight: '80vh',
                            overflow: this.props.removeCardBodyOverflow ? 'visible' : 'auto'
                        }}
                    >
                        {this.props.children}
                    </Card.Body>

                </Card>
            </Modal>
            // </Aux>
        );
    }
}

export {CustomModal};